import serialize from 'form-serialize'
import gsap from 'gsap'
import { autoScrollTo, BB } from '../../utils/utils'
import BaseComponent from './_BaseComponent'




/* FILTERS
---------------------------------------------------------------------------------------------------- */

export default class Filters extends BaseComponent {

    constructor($el, namespace) {
        super('Filters', $el, namespace)

        this.$refs.item.forEach($item => this.observer.observe($item))

        this.on()
    }

    bindProperties() {
        this.searchQuery = window.location.search

        this.parser      = new DOMParser()
        this.controller  = new AbortController()
    }


    bindHandlers() {
        this.submitHandler   = e => this.onSubmit(e)
        this.observerHandler = e => onObserver(e)
    }


    bindEvents() {
        const { $form } = this.$refs

        this.addListeners(
            [$form, 'submit', this.submitHandler],
        )

        this.observer = new IntersectionObserver(this.observerHandler)
    }




    /* Handlers
    --------------------------------------------------------- */

    onSubmit(e) {
        e.preventDefault()

        const yPos = BB(this.$refs.marqueeCtn[0]).top

        const shouldScroll = yPos < 0

        if (shouldScroll) {
            autoScrollTo(yPos + window.scrollY - APP.Layout.headerH, 1, () => {
                this.buildSearchQuery()
                this.updateState()
            })
        } else {
            this.buildSearchQuery()
            this.updateState()
        }
    }




    /* Actions
    --------------------------------------------------------- */

    updateState(slug) {
        const path = slug || this.$refs.form[0].action + this.searchQuery

        window.history.replaceState(null, null, path)

        this.fetchResults()
    }



    buildSearchQuery() {
        const obj = serialize(this.$refs.form[0], { hash: true })
        let query = ''

        Object.entries(obj).forEach(([k, v]) => {
            query += query.length ? `&${k}=${v}` : `?${k}=${v}`
        })

        this.searchQuery = query
    }



    handleNewResults(html) {
        //
    }




    /* Values
    --------------------------------------------------------- */

    fetchResults() {
        this.abortFetch()

        const url = this.$refs.form[0].action + this.searchQuery

        fetch(url, { ...fetchOptions, signal: this.controller.signal })
            .then(r => r.text())
            .then((r) => {
                this.handleNewResults(r)
            })
            .catch((err) => {
                if (err.name !== 'AbortError') {
                    console.error(err)
                }
            })
    }


    abortFetch() {
        this.controller.abort()
        this.controller = new AbortController()
    }

}




/* CONSTANTS & HELPERS
---------------------------------------------------------------------------------------------------- */


const h = new Headers()
h.append('X-Requested-With', 'XMLHttpRequest')


const fetchOptions = {
    headers     : h,
    credentials : 'same-origin',
}


const onObserver = (entries) => {
    entries.forEach((entry) => {
        entry.target.classList.toggle('js-stg', entry.isIntersecting)
    })
}
